module.exports = __webpack_public_path__ + "static/media/BIFI-MUST.4d6a88f1.png";